import {css} from 'styled-components';

import fonts from './base';

export const fontFamilyDefault = css`
  font-family: ${fonts.family.default};
`;

export const fontFamilyMono = css`
  font-family: ${fonts.family.mono};
`;
